import Cookies from 'js-cookie'

const COOKIE_PREFIX = 'comments-backfill-loading'
const COOKIE_MAX_AGE_SECONDS = 180 // 3 minutes

/**
 * Gets the cookie name for a specific channel's backfill loading state
 */
function getCookieName(channelId: string): string {
  return `${COOKIE_PREFIX}-${channelId}`
}

/**
 * Sets a cookie to indicate that a backfill is in progress for a channel.
 * The cookie will automatically expire after 3 minutes.
 */
export function setBackfillLoadingCookie(channelId: string): void {
  const cookieName = getCookieName(channelId)
  const timestamp = Date.now().toString()

  Cookies.set(cookieName, timestamp, {
    expires: COOKIE_MAX_AGE_SECONDS / 86400, // Convert seconds to days for js-cookie
    sameSite: 'strict',
  })
}

/**
 * Checks if a backfill is currently in progress for a channel.
 * Returns true if the cookie exists, false otherwise.
 */
export function isBackfillLoading(channelId: string): boolean {
  const cookieName = getCookieName(channelId)
  const cookieValue = Cookies.get(cookieName)
  return cookieValue !== undefined
}

/**
 * Gets the timestamp when the backfill started for a channel.
 * Returns the timestamp in milliseconds, or undefined if no backfill is in progress.
 */
export function getBackfillStartTime(channelId: string): number | undefined {
  const cookieName = getCookieName(channelId)
  const cookieValue = Cookies.get(cookieName)
  if (cookieValue === undefined) {
    return undefined
  }
  const timestamp = parseInt(cookieValue, 10)
  return isNaN(timestamp) ? undefined : timestamp
}

/**
 * Removes the backfill loading cookie for a channel.
 */
export function clearBackfillLoadingCookie(channelId: string): void {
  const cookieName = getCookieName(channelId)

  // Remove the loading cookie
  Cookies.remove(cookieName, {
    sameSite: 'strict',
  })
}
